import { ElephantPresetType, SearchTable } from '@aibees/elephant/types';
import { CustomDialogActionButtonProps } from '@aibees/shared/components';

export const okProps: CustomDialogActionButtonProps = {
  size: 'small',
  variant: 'contained',
  color: 'primary',
};

export const cancelProps: CustomDialogActionButtonProps = {
  size: 'small',
  variant: 'text',
};

export const EXPORT_TEMPLATE_PRESET_TYPES: Record<
  SearchTable,
  ElephantPresetType
> = {
  [SearchTable.People]:
    ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
  [SearchTable.Employees]:
    ElephantPresetType.PEOPLE_SEARCH_EXPORT_SETTINGS_COLUMNS,
  [SearchTable.Company]:
    ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS,
  /*[SearchTable.Semantic]:
    ElephantPresetType.COMPANY_SEARCH_EXPORT_SETTINGS_COLUMNS,*/
  [SearchTable.BuyingTeam]: ElephantPresetType.BUYING_TEAM_MATRIX,
};

export const DEFAULT_COMPANY_EXPORT_TEMPLATE = {
  company: {
    fields: [
      'NAME',
      'EMPLOYEE_COUNT',
      'INDUSTRY',
      'PRODUCT_AND_SERVICES',
      'WEBSITE',
      'DESCRIPTION',
      'SEO_DESCRIPTION',
      'TYPE',
      'SIZE',
      'NUMBER_OF_LOCATION',
      'FOUNDING_YEAR',
      'LINKEDIN',
      'FACEBOOK',
      'TWITTER',
      'INSTAGRAM',
      'PRIMARY_PHONE',
      'ANNUAL_REVENUE',
      'TOTAL_FUNDING',
      'LAST_FUNDING_AMOUNT',
      'LAST_FUNDING_DATE',
      'LAST_FUNDING_TYPE',
      'ID',
    ],
  },
};

export const DEFAULT_PEOPLE_EXPORT_TEMPLATE = {
  basic: {
    fields: [
      'FIRSTNAME',
      'LASTNAME',
      'FULL_NAME',
      'TITLE',
      'ORG',
      'MX_RECORD',
      'EMAIL_BUSINESS',
      'BUSINESS_STATUS',
      'DOMAIN_SETTING',
      'SMTP_PROVIDER',
      'MOBILE_PHONE',
      'LOCATION',
      'COUNTRY',
      'STATE',
      'CITY',
      'SENIORITY',
      'DEPARTMENT',
      'LINKEDIN',
      'ID',
    ],
  },
  company: {
    fields: [
      'NAME',
      'EMPLOYEE_COUNT',
      'INDUSTRY',
      'PRODUCT_AND_SERVICES',
      'WEBSITE',
      'DESCRIPTION',
      'SEO_DESCRIPTION',
      'TYPE',
      'SIZE',
      'NUMBER_OF_LOCATION',
      'FOUNDING_YEAR',
      'LINKEDIN',
      'FACEBOOK',
      'TWITTER',
      'INSTAGRAM',
      'PRIMARY_PHONE',
      'ANNUAL_REVENUE',
      'TOTAL_FUNDING',
      'LAST_FUNDING_AMOUNT',
      'LAST_FUNDING_DATE',
      'LAST_FUNDING_TYPE',
      'ID',
    ],
  },
  experiences: [
    {
      index: 0,
      fields: [],
    },
  ],
  educations: [
    {
      index: 0,
      fields: [],
    },
  ],
  awards: [
    {
      index: 0,
      fields: [],
    },
  ],
  courses: [
    {
      index: 0,
      fields: [],
    },
  ],
  projects: [
    {
      index: 0,
      fields: [],
    },
  ],
  languages: [
    {
      index: 0,
      fields: [],
    },
  ],
  certifications: [
    {
      index: 0,
      fields: [],
    },
  ],
  volunteerExperiences: [
    {
      index: 0,
      fields: [],
    },
  ],
  publications: [
    {
      index: 0,
      fields: [],
    },
  ],
  patents: [
    {
      index: 0,
      fields: [],
    },
  ],
  companyLocations: [
    {
      index: 0,
      fields: [],
    },
  ],
};

export const DEFAULT_INTEGRATION_EXPORT_TEMPLATE = {
  basic: {
    fields: [
      'FIRSTNAME',
      'LASTNAME',
      'EMAIL_BUSINESS',
      'MOBILE_PHONE',
      'LOCATION',
      'LINKEDIN',
      'WEBSITE',
    ],
  },
  company: {
    fields: ['NAME', 'DOMAIN'],
  },
  experiences: [
    {
      index: 0,
      fields: [],
    },
  ],
  educations: [
    {
      index: 0,
      fields: [],
    },
  ],
  awards: [
    {
      index: 0,
      fields: [],
    },
  ],
  courses: [
    {
      index: 0,
      fields: [],
    },
  ],
  projects: [
    {
      index: 0,
      fields: [],
    },
  ],
  languages: [
    {
      index: 0,
      fields: [],
    },
  ],
  certifications: [
    {
      index: 0,
      fields: [],
    },
  ],
  volunteerExperiences: [
    {
      index: 0,
      fields: [],
    },
  ],
  publications: [
    {
      index: 0,
      fields: [],
    },
  ],
  patents: [
    {
      index: 0,
      fields: [],
    },
  ],
  companyLocations: [
    {
      index: 0,
      fields: [],
    },
  ],
};

export const EXPORT_TEMPLATE_LABEL_WIDTH = 328;
export const EXPORT_TEMPLATE_LABEL_WITH_VISIBILITY_ICON_WIDTH = 299;
